var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSection34(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111,
    height: 106.459,
    viewBox: "0 0 111 106.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7130",
    "data-name": "Rectangle 7130",
    width: 111,
    height: 106.459,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9207",
    "data-name": "Group 9207",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9003",
    "data-name": "Group 9003",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13421",
    "data-name": "Path 13421",
    d: "M109.983,51.842H1.018a1.017,1.017,0,0,1-.893-1.5L8.342,35.37a1.012,1.012,0,0,1,.89-.528h92.537a1.019,1.019,0,0,1,.893.528l8.214,14.968a1.017,1.017,0,0,1-.893,1.5M2.735,49.81H108.266l-7.1-12.933H9.834Z",
    transform: "translate(0.001 51.102)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13422",
    "data-name": "Path 13422",
    d: "M36.512,38.071H33.081a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(47.029 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13423",
    "data-name": "Path 13423",
    d: "M33.407,38.071H29.974a1.016,1.016,0,0,1,0-2.033h3.434a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(42.475 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13424",
    "data-name": "Path 13424",
    d: "M27.2,38.071H23.763a1.016,1.016,0,0,1,0-2.033H27.2a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(33.365 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13425",
    "data-name": "Path 13425",
    d: "M20.985,38.071H17.554a1.016,1.016,0,0,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(24.256 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13426",
    "data-name": "Path 13426",
    d: "M14.774,38.071H11.343a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(15.146 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13427",
    "data-name": "Path 13427",
    d: "M39.62,38.071H36.186a1.016,1.016,0,1,1,0-2.033H39.62a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(51.583 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13428",
    "data-name": "Path 13428",
    d: "M30.3,38.071H26.87a1.016,1.016,0,1,1,0-2.033H30.3a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(37.919 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13429",
    "data-name": "Path 13429",
    d: "M24.091,38.071H20.66a1.016,1.016,0,0,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(28.811 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13430",
    "data-name": "Path 13430",
    d: "M17.88,38.071H14.449a1.016,1.016,0,0,1,0-2.033H17.88a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(19.702 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13431",
    "data-name": "Path 13431",
    d: "M11.669,38.071H8.236a1.016,1.016,0,0,1,0-2.033h3.434a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(10.592 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13432",
    "data-name": "Path 13432",
    d: "M8.564,38.071H5.133a1.016,1.016,0,0,1,0-2.033H8.564a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(6.038 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13433",
    "data-name": "Path 13433",
    d: "M42.723,38.071H39.292a1.016,1.016,0,0,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(56.138 52.856)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13434",
    "data-name": "Path 13434",
    d: "M36.512,40.331H33.081a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(47.029 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13435",
    "data-name": "Path 13435",
    d: "M33.407,40.331H29.974a1.016,1.016,0,0,1,0-2.033h3.434a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(42.475 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13436",
    "data-name": "Path 13436",
    d: "M27.2,40.331H23.763a1.016,1.016,0,0,1,0-2.033H27.2a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(33.365 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13437",
    "data-name": "Path 13437",
    d: "M20.985,40.331H17.554a1.016,1.016,0,0,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(24.256 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13438",
    "data-name": "Path 13438",
    d: "M14.774,40.331H11.343a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(15.146 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13439",
    "data-name": "Path 13439",
    d: "M39.62,40.331H36.186a1.016,1.016,0,1,1,0-2.033H39.62a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(51.583 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13440",
    "data-name": "Path 13440",
    d: "M30.3,40.331H26.87a1.016,1.016,0,1,1,0-2.033H30.3a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(37.919 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13441",
    "data-name": "Path 13441",
    d: "M24.091,40.331H20.66a1.016,1.016,0,0,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(28.811 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13442",
    "data-name": "Path 13442",
    d: "M17.88,40.331H14.449a1.016,1.016,0,0,1,0-2.033H17.88a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(19.702 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13443",
    "data-name": "Path 13443",
    d: "M11.669,40.331H8.236a1.016,1.016,0,0,1,0-2.033h3.434a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(10.592 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13444",
    "data-name": "Path 13444",
    d: "M8.564,40.331H5.133a1.016,1.016,0,0,1,0-2.033H8.564a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(6.038 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13445",
    "data-name": "Path 13445",
    d: "M42.723,40.331H39.292a1.016,1.016,0,0,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(56.138 56.171)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13446",
    "data-name": "Path 13446",
    d: "M35.038,39.127H31.607a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(44.867 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13447",
    "data-name": "Path 13447",
    d: "M31.933,39.127H28.5a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(40.313 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13448",
    "data-name": "Path 13448",
    d: "M25.722,39.127H22.291a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(31.203 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13449",
    "data-name": "Path 13449",
    d: "M19.511,39.127H16.08a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(22.094 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13450",
    "data-name": "Path 13450",
    d: "M13.3,39.127H9.869a1.016,1.016,0,1,1,0-2.033H13.3a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(12.984 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13451",
    "data-name": "Path 13451",
    d: "M38.144,39.127H34.713a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(49.422 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13452",
    "data-name": "Path 13452",
    d: "M28.827,39.127H25.4a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(35.757 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13453",
    "data-name": "Path 13453",
    d: "M22.617,39.127H19.186a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(26.649 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13454",
    "data-name": "Path 13454",
    d: "M16.406,39.127H12.975a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(17.54 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13455",
    "data-name": "Path 13455",
    d: "M10.2,39.127H6.764a1.016,1.016,0,1,1,0-2.033H10.2a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(8.43 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13456",
    "data-name": "Path 13456",
    d: "M41.249,39.127H37.818a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(53.976 54.405)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13457",
    "data-name": "Path 13457",
    d: "M35.038,41.486H31.607a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(44.867 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13458",
    "data-name": "Path 13458",
    d: "M31.933,41.486H28.5a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(40.313 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13459",
    "data-name": "Path 13459",
    d: "M34.662,41.486H16.08a1.016,1.016,0,0,1,0-2.033H34.662a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(22.094 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13460",
    "data-name": "Path 13460",
    d: "M13.3,41.486H9.869a1.016,1.016,0,1,1,0-2.033H13.3a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(12.984 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13461",
    "data-name": "Path 13461",
    d: "M38.144,41.486H34.713a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(49.422 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13462",
    "data-name": "Path 13462",
    d: "M28.827,41.486H25.4a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(35.757 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13463",
    "data-name": "Path 13463",
    d: "M16.406,41.486H12.975a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(17.54 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13464",
    "data-name": "Path 13464",
    d: "M10.2,41.486H6.764a1.016,1.016,0,1,1,0-2.033H10.2a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(8.43 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13465",
    "data-name": "Path 13465",
    d: "M7.247,41.486H3.816a1.016,1.016,0,1,1,0-2.033H7.247a1.016,1.016,0,1,1,0,2.033",
    transform: "translate(4.107 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13466",
    "data-name": "Path 13466",
    d: "M41.249,41.486H37.818a1.016,1.016,0,1,1,0-2.033h3.431a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(53.976 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13467",
    "data-name": "Path 13467",
    d: "M44.4,41.486H40.962a1.016,1.016,0,1,1,0-2.033H44.4a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(58.587 57.865)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13468",
    "data-name": "Path 13468",
    d: "M109.984,46.458H1.016A1.016,1.016,0,0,1,0,45.441V41.926A1.016,1.016,0,0,1,1.016,40.91H109.984A1.016,1.016,0,0,1,111,41.926v3.515a1.016,1.016,0,0,1-1.016,1.016M2.035,44.425H108.967V42.943H2.035Z",
    transform: "translate(0 60.002)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13469",
    "data-name": "Path 13469",
    d: "M85.165,66.869H11.846a7.085,7.085,0,0,1-7.077-7.077V7.077A7.085,7.085,0,0,1,11.846,0H85.165a7.085,7.085,0,0,1,7.077,7.077V59.792a7.085,7.085,0,0,1-7.077,7.077M11.846,2.033A5.05,5.05,0,0,0,6.8,7.077V59.792a5.05,5.05,0,0,0,5.044,5.044H85.165a5.048,5.048,0,0,0,5.042-5.044V7.077a5.048,5.048,0,0,0-5.042-5.044Z",
    transform: "translate(6.995 0.001)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13470",
    "data-name": "Path 13470",
    d: "M91.224,23.037H5.786a1.016,1.016,0,1,1,0-2.033H91.224a1.016,1.016,0,0,1,0,2.033",
    transform: "translate(6.996 30.807)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13471",
    "data-name": "Path 13471",
    d: "M54.992,44.98H15a1.016,1.016,0,0,1-.281-1.993l8.332-2.38a5.062,5.062,0,0,0,3.656-4.849V27.3a1.016,1.016,0,0,1,1.016-1.016H42.266A1.015,1.015,0,0,1,43.282,27.3v8.456a5.065,5.065,0,0,0,3.658,4.849l8.33,2.38a1.016,1.016,0,0,1-.279,1.993M22.257,42.947H47.732l-1.349-.385a7.111,7.111,0,0,1-5.133-6.806V28.318H28.739v7.439a7.107,7.107,0,0,1-5.131,6.806Z",
    transform: "translate(20.506 38.552)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13472",
    "data-name": "Path 13472",
    d: "M25.618,32.257a5.274,5.274,0,0,1-5.242-4.884,1.018,1.018,0,0,1,1.014-1.088h8.453a1.014,1.014,0,0,1,1.014,1.088,5.272,5.272,0,0,1-5.239,4.884M22.68,28.318a3.217,3.217,0,0,0,5.876,0Z",
    transform: "translate(29.882 38.552)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13473",
    "data-name": "Path 13473",
    d: "M13.085,9.286H12.044L13.1,3.105h2.252a2.021,2.021,0,0,1,.932.168,1.206,1.206,0,0,1,.5.528,2,2,0,0,1,.192.927,2.023,2.023,0,0,1-.4,1.317,1.8,1.8,0,0,1-1.157.614,2.719,2.719,0,0,1,.414.659,17.477,17.477,0,0,1,.738,1.968H15.45c-.044-.173-.195-.649-.451-1.421a3.66,3.66,0,0,0-.37-.839.7.7,0,0,0-.252-.237,1.04,1.04,0,0,0-.427-.062h-.424Zm.6-3.485h.55a3.746,3.746,0,0,0,1.058-.1.943.943,0,0,0,.461-.365,1.02,1.02,0,0,0,.183-.587A.576.576,0,0,0,15.7,4.24a1.118,1.118,0,0,0-.59-.1H13.97Z",
    transform: "translate(17.665 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13474",
    "data-name": "Path 13474",
    d: "M14.306,9.286,15.364,3.1h3.754l-.175,1.034H16.23l-.242,1.4h2.625l-.175,1.034H15.81l-.289,1.677h2.916l-.175,1.034Z",
    transform: "translate(20.982 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13475",
    "data-name": "Path 13475",
    d: "M16.468,7.345l.992-.064a1.965,1.965,0,0,0,.113.693.657.657,0,0,0,.308.3,1.275,1.275,0,0,0,.585.113,1.058,1.058,0,0,0,.723-.212.7.7,0,0,0,.244-.553.643.643,0,0,0-.141-.414,2.8,2.8,0,0,0-.72-.474,5.758,5.758,0,0,1-.979-.609,1.465,1.465,0,0,1-.377-.535,1.884,1.884,0,0,1-.131-.72,1.8,1.8,0,0,1,.483-1.317,1.766,1.766,0,0,1,1.325-.493,1.873,1.873,0,0,1,1.354.488A1.993,1.993,0,0,1,20.8,4.933l-1,.052q-.078-.914-.923-.915a.9.9,0,0,0-.614.175.61.61,0,0,0-.2.481.579.579,0,0,0,.187.449A3.557,3.557,0,0,0,19,5.648a5.558,5.558,0,0,1,.969.6,1.4,1.4,0,0,1,.37.523,1.8,1.8,0,0,1,.128.7A1.943,1.943,0,0,1,19.912,8.9a1.971,1.971,0,0,1-1.458.553,2.2,2.2,0,0,1-1.164-.291,1.474,1.474,0,0,1-.659-.775,2.889,2.889,0,0,1-.163-1.041",
    transform: "translate(24.153 4.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13476",
    "data-name": "Path 13476",
    d: "M20.4,9.286H19.361l.886-5.148H18.724L18.9,3.1h4.026L22.75,4.138H21.285Z",
    transform: "translate(27.462 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13477",
    "data-name": "Path 13477",
    d: "M21.508,9.286H20.467l1.058-6.181h2.252a2.021,2.021,0,0,1,.932.168,1.206,1.206,0,0,1,.5.528,2,2,0,0,1,.192.927A2.023,2.023,0,0,1,25,6.045a1.8,1.8,0,0,1-1.157.614,2.719,2.719,0,0,1,.414.659,17.476,17.476,0,0,1,.738,1.968h-1.12c-.044-.173-.195-.649-.451-1.421a3.66,3.66,0,0,0-.37-.839A.7.7,0,0,0,22.8,6.79a1.04,1.04,0,0,0-.427-.062h-.424Zm.6-3.485h.55a3.746,3.746,0,0,0,1.058-.1.943.943,0,0,0,.461-.365,1.02,1.02,0,0,0,.183-.587.576.576,0,0,0-.232-.511,1.118,1.118,0,0,0-.59-.1H22.393Z",
    transform: "translate(30.018 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13478",
    "data-name": "Path 13478",
    d: "M22.677,9.286l1.1-6.181h1.041l-1.1,6.181Z",
    transform: "translate(33.259 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13479",
    "data-name": "Path 13479",
    d: "M27.158,7.123l1.051.19a3.316,3.316,0,0,1-.935,1.608,2.124,2.124,0,0,1-1.431.533A1.755,1.755,0,0,1,24.4,8.788a3.152,3.152,0,0,1-.533-2,4.937,4.937,0,0,1,.387-2.01,3.07,3.07,0,0,1,.989-1.293,2.212,2.212,0,0,1,1.3-.424,1.8,1.8,0,0,1,1.315.518,2.326,2.326,0,0,1,.617,1.485l-1,.118a1.386,1.386,0,0,0-.328-.792.855.855,0,0,0-.622-.232,1.217,1.217,0,0,0-.755.281,2.14,2.14,0,0,0-.617.947,4.044,4.044,0,0,0-.254,1.46,1.9,1.9,0,0,0,.3,1.145.864.864,0,0,0,.713.4,1.064,1.064,0,0,0,.74-.316,1.912,1.912,0,0,0,.511-.955",
    transform: "translate(35.002 4.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13480",
    "data-name": "Path 13480",
    d: "M27.863,9.286H26.825l.886-5.148H26.188L26.363,3.1h4.026l-.175,1.034H28.749Z",
    transform: "translate(38.409 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13481",
    "data-name": "Path 13481",
    d: "M27.929,9.286,28.987,3.1h3.754l-.175,1.034H29.853l-.242,1.4h2.625L32.06,6.576H29.433l-.289,1.677H32.06l-.175,1.034Z",
    transform: "translate(40.962 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13482",
    "data-name": "Path 13482",
    d: "M30.038,9.286,31.1,3.105h1.359a5.019,5.019,0,0,1,.967.062,1.587,1.587,0,0,1,.747.417,2.14,2.14,0,0,1,.506.834,3.734,3.734,0,0,1,.185,1.251,5.1,5.1,0,0,1-.187,1.418,3.845,3.845,0,0,1-.535,1.137,2.248,2.248,0,0,1-1.475,1.009,4.5,4.5,0,0,1-.836.054Zm1.211-.994h.528a2.86,2.86,0,0,0,.809-.079,1.308,1.308,0,0,0,.572-.417,2.69,2.69,0,0,0,.459-.873,3.877,3.877,0,0,0,.195-1.29,2.342,2.342,0,0,0-.158-.955.9.9,0,0,0-.427-.466,1.825,1.825,0,0,0-.666-.084h-.6Z",
    transform: "translate(44.056 4.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13483",
    "data-name": "Path 13483",
    d: "M11.634,13.486H10.593l1.058-6.181h2.037a1.935,1.935,0,0,1,.893.168,1.224,1.224,0,0,1,.5.516,1.8,1.8,0,0,1,.19.861,2.756,2.756,0,0,1-.229,1.132,1.829,1.829,0,0,1-.565.765,1.909,1.909,0,0,1-.8.335,6.436,6.436,0,0,1-.994.049h-.649Zm.577-3.382h.3a3.621,3.621,0,0,0,1.066-.1.948.948,0,0,0,.466-.385,1.16,1.16,0,0,0,.185-.654.578.578,0,0,0-.269-.553,1.759,1.759,0,0,0-.715-.089h-.728Z",
    transform: "translate(15.536 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13484",
    "data-name": "Path 13484",
    d: "M13.74,13.486H12.7l1.058-6.181h2.252a2.021,2.021,0,0,1,.932.168,1.206,1.206,0,0,1,.5.528,2,2,0,0,1,.192.927,2.023,2.023,0,0,1-.4,1.317,1.8,1.8,0,0,1-1.157.614,2.719,2.719,0,0,1,.414.659,17.477,17.477,0,0,1,.738,1.968h-1.12c-.044-.173-.195-.649-.451-1.421a3.66,3.66,0,0,0-.37-.839.7.7,0,0,0-.252-.237,1.04,1.04,0,0,0-.427-.062h-.424Zm.6-3.485h.55a3.746,3.746,0,0,0,1.058-.1.943.943,0,0,0,.461-.365,1.02,1.02,0,0,0,.183-.587.576.576,0,0,0-.232-.511,1.118,1.118,0,0,0-.59-.1H14.625Z",
    transform: "translate(18.625 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13485",
    "data-name": "Path 13485",
    d: "M15.086,11.123a5.465,5.465,0,0,1,.269-1.648,3.447,3.447,0,0,1,1.014-1.65,2.341,2.341,0,0,1,1.549-.562,1.9,1.9,0,0,1,1.51.7,2.828,2.828,0,0,1,.592,1.894,4.756,4.756,0,0,1-.424,2.008,3.267,3.267,0,0,1-1.053,1.354,2.347,2.347,0,0,1-1.381.439,1.789,1.789,0,0,1-1.438-.634,2.818,2.818,0,0,1-.636-1.9M16.12,11.1a1.644,1.644,0,0,0,.335,1.088,1.017,1.017,0,0,0,.816.407,1.219,1.219,0,0,0,.765-.3,2.391,2.391,0,0,0,.661-1,3.7,3.7,0,0,0,.281-1.406A1.841,1.841,0,0,0,18.633,8.7a.975.975,0,0,0-.8-.377,1.247,1.247,0,0,0-.782.306,2.355,2.355,0,0,0-.661.987A3.983,3.983,0,0,0,16.12,11.1",
    transform: "translate(22.126 10.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13486",
    "data-name": "Path 13486",
    d: "M17.389,13.486l1.058-6.181h1.359a5.019,5.019,0,0,1,.967.062,1.587,1.587,0,0,1,.747.417,2.14,2.14,0,0,1,.506.834,3.734,3.734,0,0,1,.185,1.251,5.1,5.1,0,0,1-.187,1.418,3.845,3.845,0,0,1-.535,1.137,2.248,2.248,0,0,1-1.475,1.009,4.5,4.5,0,0,1-.836.054Zm1.211-.994h.528a2.86,2.86,0,0,0,.809-.079A1.308,1.308,0,0,0,20.509,12a2.69,2.69,0,0,0,.459-.873,3.877,3.877,0,0,0,.195-1.29,2.342,2.342,0,0,0-.158-.955.9.9,0,0,0-.427-.466,1.825,1.825,0,0,0-.666-.084h-.6Z",
    transform: "translate(25.504 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13487",
    "data-name": "Path 13487",
    d: "M20.476,7.305h1.043l-.572,3.357-.138.809a1.826,1.826,0,0,0-.017.212.787.787,0,0,0,.844.846.97.97,0,0,0,.967-.636,5.932,5.932,0,0,0,.289-1.206l.6-3.382h1.041l-.6,3.374a7.984,7.984,0,0,1-.372,1.519,2.3,2.3,0,0,1-.77,1.048,2.034,2.034,0,0,1-1.209.345,1.746,1.746,0,0,1-1.322-.508,1.925,1.925,0,0,1-.483-1.386,8.456,8.456,0,0,1,.148-1.137Z",
    transform: "translate(29.008 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13488",
    "data-name": "Path 13488",
    d: "M25.353,11.323l1.051.19a3.316,3.316,0,0,1-.935,1.608,2.124,2.124,0,0,1-1.431.533,1.755,1.755,0,0,1-1.445-.666,3.152,3.152,0,0,1-.533-2,4.937,4.937,0,0,1,.387-2.01,3.07,3.07,0,0,1,.989-1.293,2.212,2.212,0,0,1,1.3-.424,1.8,1.8,0,0,1,1.315.518,2.326,2.326,0,0,1,.617,1.485l-1,.118a1.386,1.386,0,0,0-.328-.792.855.855,0,0,0-.622-.232,1.217,1.217,0,0,0-.755.281,2.139,2.139,0,0,0-.617.947,4.044,4.044,0,0,0-.254,1.46,1.9,1.9,0,0,0,.3,1.145.864.864,0,0,0,.713.4,1.064,1.064,0,0,0,.74-.316,1.912,1.912,0,0,0,.511-.955",
    transform: "translate(32.355 10.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13489",
    "data-name": "Path 13489",
    d: "M26.058,13.487H25.019L25.9,8.339H24.383l.175-1.034h4.026l-.175,1.034H26.943Z",
    transform: "translate(35.762 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13490",
    "data-name": "Path 13490",
    d: "M31.136,13.487h-.969L28.8,9.333l-.71,4.154h-.972l1.058-6.181h.972l1.369,4.137.71-4.137H32.2Z",
    transform: "translate(39.772 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13491",
    "data-name": "Path 13491",
    d: "M29.5,11.123a5.465,5.465,0,0,1,.269-1.648,3.447,3.447,0,0,1,1.014-1.65,2.341,2.341,0,0,1,1.549-.562,1.9,1.9,0,0,1,1.51.7,2.828,2.828,0,0,1,.592,1.894,4.756,4.756,0,0,1-.424,2.008,3.267,3.267,0,0,1-1.053,1.354,2.347,2.347,0,0,1-1.381.439,1.789,1.789,0,0,1-1.438-.634,2.818,2.818,0,0,1-.636-1.9m1.034-.027a1.644,1.644,0,0,0,.335,1.088,1.017,1.017,0,0,0,.816.407,1.219,1.219,0,0,0,.765-.3,2.391,2.391,0,0,0,.661-1A3.7,3.7,0,0,0,33.4,9.885,1.841,1.841,0,0,0,33.051,8.7a.975.975,0,0,0-.8-.377,1.247,1.247,0,0,0-.782.306,2.355,2.355,0,0,0-.661.987,3.983,3.983,0,0,0-.271,1.478",
    transform: "translate(43.273 10.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13492",
    "data-name": "Path 13492",
    d: "M33.684,13.487H32.646l.886-5.148H32.009l.175-1.034H36.21l-.175,1.034H34.57Z",
    transform: "translate(46.947 10.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13493",
    "data-name": "Path 13493",
    d: "M13.233,16.321H11.225l-.614,1.367H9.54l2.871-6.181h1.152l.821,6.181H13.4ZM13.1,15.292l-.291-2.486-1.12,2.486Z",
    transform: "translate(13.992 16.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13494",
    "data-name": "Path 13494",
    d: "M11.964,17.687l1.061-6.181h1.043l-.888,5.148h2.588l-.175,1.034Z",
    transform: "translate(17.548 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13495",
    "data-name": "Path 13495",
    d: "M13.91,17.687l1.061-6.181h1.043l-.888,5.148h2.588l-.175,1.034Z",
    transform: "translate(20.401 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13496",
    "data-name": "Path 13496",
    d: "M15.979,15.323a5.465,5.465,0,0,1,.269-1.648,3.447,3.447,0,0,1,1.014-1.65,2.341,2.341,0,0,1,1.549-.562,1.9,1.9,0,0,1,1.51.7,2.828,2.828,0,0,1,.592,1.894,4.756,4.756,0,0,1-.424,2.008,3.268,3.268,0,0,1-1.053,1.354,2.347,2.347,0,0,1-1.381.439,1.789,1.789,0,0,1-1.438-.634,2.818,2.818,0,0,1-.636-1.9m1.034-.027a1.644,1.644,0,0,0,.335,1.088,1.017,1.017,0,0,0,.816.407,1.219,1.219,0,0,0,.765-.3,2.391,2.391,0,0,0,.661-1,3.7,3.7,0,0,0,.281-1.406,1.841,1.841,0,0,0-.345-1.182.975.975,0,0,0-.8-.377,1.247,1.247,0,0,0-.782.306,2.355,2.355,0,0,0-.661.987,3.984,3.984,0,0,0-.271,1.478",
    transform: "translate(23.436 16.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13497",
    "data-name": "Path 13497",
    d: "M22.769,17.687H21.715L21.6,13.168l-1.845,4.519H18.679l-.187-6.181H19.51l.042,4.327,1.741-4.327h1.132l.116,4.28,1.667-4.28h1.009Z",
    transform: "translate(27.121 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13498",
    "data-name": "Path 13498",
    d: "M21.181,17.687l1.058-6.181h3.754l-.175,1.034H23.1l-.242,1.4h2.625l-.175,1.034H22.685L22.4,16.653h2.916l-.175,1.034Z",
    transform: "translate(31.065 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13499",
    "data-name": "Path 13499",
    d: "M23.29,17.686l1.058-6.181h1.359a5.019,5.019,0,0,1,.967.062,1.587,1.587,0,0,1,.747.417,2.139,2.139,0,0,1,.506.834,3.734,3.734,0,0,1,.185,1.251,5.1,5.1,0,0,1-.187,1.418,3.845,3.845,0,0,1-.535,1.137,2.248,2.248,0,0,1-1.475,1.009,4.5,4.5,0,0,1-.836.054Zm1.211-.994h.528a2.86,2.86,0,0,0,.809-.079,1.308,1.308,0,0,0,.572-.417,2.69,2.69,0,0,0,.459-.873,3.877,3.877,0,0,0,.195-1.29,2.342,2.342,0,0,0-.158-.955.9.9,0,0,0-.427-.466,1.825,1.825,0,0,0-.666-.084h-.6Z",
    transform: "translate(34.159 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13500",
    "data-name": "Path 13500",
    d: "M31.031,17.687H29.978l-.116-4.519-1.845,4.519H26.941l-.187-6.181h1.019l.042,4.327,1.741-4.327h1.132l.116,4.28,1.667-4.28H33.48Z",
    transform: "translate(39.239 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13501",
    "data-name": "Path 13501",
    d: "M29.391,17.687l1.1-6.181h1.041l-1.1,6.181Z",
    transform: "translate(43.107 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13502",
    "data-name": "Path 13502",
    d: "M32.313,17.687H31.275l.886-5.148H30.638l.175-1.034h4.026l-.175,1.034H33.2Z",
    transform: "translate(44.936 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13503",
    "data-name": "Path 13503",
    d: "M35.845,14.926H33.9l-.474,2.76H32.382l1.058-6.181h1.043l-.409,2.388H36.02l.409-2.388h1.038L36.41,17.687H35.372Z",
    transform: "translate(47.494 16.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13504",
    "data-name": "Path 13504",
    d: "M10.746,21.887H9.708l.886-5.148H9.071l.175-1.034h4.026L13.1,16.739H11.632Z",
    transform: "translate(13.305 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13505",
    "data-name": "Path 13505",
    d: "M14.278,19.127H12.329l-.474,2.76H10.815l1.058-6.181h1.043l-.409,2.388h1.946l.409-2.388H15.9l-1.058,6.181H13.8Z",
    transform: "translate(15.862 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13506",
    "data-name": "Path 13506",
    d: "M13.024,21.887l1.1-6.181h1.041l-1.1,6.181Z",
    transform: "translate(19.102 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13507",
    "data-name": "Path 13507",
    d: "M14.123,19.946l.989-.064a1.952,1.952,0,0,0,.116.693.646.646,0,0,0,.308.3,1.256,1.256,0,0,0,.582.113,1.066,1.066,0,0,0,.725-.212.712.712,0,0,0,.244-.553.632.632,0,0,0-.143-.414,2.823,2.823,0,0,0-.718-.474,5.919,5.919,0,0,1-.982-.609,1.494,1.494,0,0,1-.377-.535,1.933,1.933,0,0,1-.128-.72,1.8,1.8,0,0,1,.481-1.317,1.772,1.772,0,0,1,1.327-.493,1.881,1.881,0,0,1,1.354.488,1.981,1.981,0,0,1,.555,1.381l-1,.052q-.078-.914-.923-.915a.889.889,0,0,0-.612.175.6.6,0,0,0-.2.481.586.586,0,0,0,.185.449,3.668,3.668,0,0,0,.738.474,5.508,5.508,0,0,1,.967.6,1.38,1.38,0,0,1,.372.523,1.8,1.8,0,0,1,.128.7,1.953,1.953,0,0,1-.553,1.431,1.977,1.977,0,0,1-1.46.553,2.2,2.2,0,0,1-1.164-.291,1.48,1.48,0,0,1-.656-.775,2.837,2.837,0,0,1-.163-1.041",
    transform: "translate(20.713 22.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13508",
    "data-name": "Path 13508",
    d: "M20.6,19.723l1.051.19a3.316,3.316,0,0,1-.935,1.608,2.124,2.124,0,0,1-1.431.533,1.755,1.755,0,0,1-1.445-.666,3.152,3.152,0,0,1-.533-2,4.937,4.937,0,0,1,.387-2.01,3.07,3.07,0,0,1,.989-1.293,2.212,2.212,0,0,1,1.3-.424,1.8,1.8,0,0,1,1.315.518,2.327,2.327,0,0,1,.617,1.485l-1,.118a1.386,1.386,0,0,0-.328-.792.855.855,0,0,0-.622-.232,1.217,1.217,0,0,0-.755.281,2.139,2.139,0,0,0-.617.947,4.044,4.044,0,0,0-.254,1.46,1.9,1.9,0,0,0,.3,1.145.864.864,0,0,0,.713.4,1.064,1.064,0,0,0,.74-.316,1.912,1.912,0,0,0,.511-.955",
    transform: "translate(25.387 22.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13509",
    "data-name": "Path 13509",
    d: "M22.962,20.521H20.954l-.614,1.367H19.269l2.871-6.181h1.152l.821,6.181h-.987Zm-.133-1.029-.291-2.486-1.12,2.486Z",
    transform: "translate(28.261 23.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13510",
    "data-name": "Path 13510",
    d: "M22.734,21.886H21.693l1.058-6.181H25a2.021,2.021,0,0,1,.932.168,1.206,1.206,0,0,1,.5.528,2,2,0,0,1,.192.927,2.023,2.023,0,0,1-.4,1.317,1.8,1.8,0,0,1-1.157.614,2.72,2.72,0,0,1,.414.659,17.477,17.477,0,0,1,.738,1.968H25.1c-.044-.173-.195-.649-.451-1.421a3.66,3.66,0,0,0-.37-.839.7.7,0,0,0-.252-.237,1.04,1.04,0,0,0-.427-.062h-.424Zm.6-3.485h.55a3.746,3.746,0,0,0,1.058-.1.943.943,0,0,0,.461-.365,1.02,1.02,0,0,0,.183-.587.576.576,0,0,0-.232-.511,1.118,1.118,0,0,0-.59-.1H23.619Z",
    transform: "translate(31.816 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13511",
    "data-name": "Path 13511",
    d: "M23.957,21.886l1.058-6.181h1.359a5.019,5.019,0,0,1,.967.062,1.587,1.587,0,0,1,.747.417,2.14,2.14,0,0,1,.506.834,3.734,3.734,0,0,1,.185,1.251,5.1,5.1,0,0,1-.187,1.418,3.845,3.845,0,0,1-.535,1.137,2.248,2.248,0,0,1-1.475,1.009,4.5,4.5,0,0,1-.836.054Zm1.211-.994H25.7a2.86,2.86,0,0,0,.809-.079,1.308,1.308,0,0,0,.572-.417,2.69,2.69,0,0,0,.459-.873,3.877,3.877,0,0,0,.195-1.29,2.342,2.342,0,0,0-.158-.955.9.9,0,0,0-.427-.466,1.825,1.825,0,0,0-.666-.084h-.6Z",
    transform: "translate(35.137 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13512",
    "data-name": "Path 13512",
    d: "M29.089,21.887H28.05l.886-5.148H27.414l.175-1.034h4.026l-.175,1.034H29.974Z",
    transform: "translate(40.207 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13513",
    "data-name": "Path 13513",
    d: "M31.382,21.886H30.336l.434-2.407-1.408-3.774H30.47l.634,1.744c.15.414.252.718.3.908q.137-.281.311-.585l.469-.8.735-1.263h1.211L31.792,19.6Z",
    transform: "translate(43.064 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13514",
    "data-name": "Path 13514",
    d: "M32.3,21.886H31.264l1.058-6.181H34.36a1.936,1.936,0,0,1,.893.168,1.224,1.224,0,0,1,.5.516,1.8,1.8,0,0,1,.19.861,2.756,2.756,0,0,1-.229,1.132,1.83,1.83,0,0,1-.565.765,1.91,1.91,0,0,1-.8.335,6.435,6.435,0,0,1-.994.049h-.649Zm.577-3.382h.3a3.621,3.621,0,0,0,1.066-.1.948.948,0,0,0,.466-.385,1.16,1.16,0,0,0,.185-.654.578.578,0,0,0-.269-.553,1.759,1.759,0,0,0-.715-.089h-.728Z",
    transform: "translate(45.854 23.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13515",
    "data-name": "Path 13515",
    d: "M33.368,21.887l1.058-6.181H38.18L38,16.739H35.292l-.242,1.4h2.625L37.5,19.176H34.872l-.289,1.677H37.5l-.175,1.034Z",
    transform: "translate(48.939 23.035)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection34);
export default __webpack_public_path__ + "static/media/home_section_3_4.2461e5c366fc87b6d6d4ec04d137d043.svg";
export { ForwardRef as ReactComponent };